/**
 * Attestato — the Art. 4 register. Nominal certificate per person per course.
 * Source: Marko spec §9. coreBOS-A: existing LMS certificate output; system-generated.
 *
 * Write-once: created automatically on course completion, never edited.
 * `codice_attestato` is auto-generated (numbering: ATT).
 * `ente_certificatore` auto = Evolutivo; for third-party path, the issuing body.
 * This is what an AI Act inspector asks for when auditing Art. 4 literacy obligations.
 * Retention matters: medium GDPR sensitivity (nominal personal data + audit evidence).
 */
export const certificateDescriptor = {
    slug: 'certificate',
    kind: 'document',
    label: { singular: 'Attestato', plural: 'Attestati' },
    table: 'ai_portal_certificate',
    idStrategy: 'sha256',
    fields: [
        { name: 'data_completamento', type: 'date', label: 'Data completamento', required: true },
        { name: 'esito', type: 'text', label: 'Esito', required: true }, // Superato | Non superato
        { name: 'punteggio', type: 'number', label: 'Punteggio' },
        { name: 'codice_attestato', type: 'text', label: 'Codice attestato', required: true },
        { name: 'ente_certificatore', type: 'text', label: 'Ente certificatore' },
    ],
    relations: [
        { name: 'corso', kind: 'belongsTo', target: 'course' },
        { name: 'utente', kind: 'belongsTo', target: 'ai_user' },
    ],
    behaviors: {
        audit: true,
        numbering: { prefix: 'ATT', seq: 'ai_portal_certificate_no' },
        tenantScoped: true,
    },
    emits: ['certificate.issued'],
    ui: { mode: 'generated', icon: 'FileDoneOutlined', navGroup: 'Compliance', navOrder: 12 },
};
